module.exports = __webpack_public_path__ + "static/media/29BDOS18.111134f0.jpg";